import {
    IItalianStory,
    ItalianStoriesResponseTo,
    ItalianStoryResponseTo,
    StoriesEntity,
    TagsEntity,
} from "../../models/italianStory";
import { randomUid } from "../randomIds";
import {
    HeadSectionContent,
    SectionsTitleText,
} from "../../models/common/common";
import colors from "../../styles/colors.module.scss";

const tagsFirst: TagsEntity[] = [
    {
        label: "Italy",
        color: " #55ce97",
    },
    {
        label: "Travel",
        color: "#92a5ef",
    },
];

const cardStoriesTitle =
    "Italian lands fascinate and broaden the horizons and, no doubt, are worth the visit.";
const cardStoriesReadTime = "2 minutes";
const cardStoriesVendor = "Play Italy";
const cardStoriesDate = "Feb 03, 2022";

export const cardStoriesContent1: ItalianStoriesResponseTo = {
    title: cardStoriesTitle,
    _id: "discover-the-beauty-of-italy",
    coverImage:
        "https://images.unsplash.com/photo-1511135570219-bbad9a02f103?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    time: cardStoriesReadTime,
    author: cardStoriesVendor,
    date: cardStoriesDate,
    tags: tagsFirst,
};
export const cardStoriesContent2: ItalianStoriesResponseTo = {
    title: cardStoriesTitle,
    _id: "discover-the-beauty-of-italy",
    coverImage:
        "https://images.unsplash.com/photo-1592891398015-789d78a93c06?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80",
    time: cardStoriesReadTime,
    author: cardStoriesVendor,
    date: cardStoriesDate,
    tags: tagsFirst,
};
export const cardStoriesContent3: ItalianStoriesResponseTo = {
    title: cardStoriesTitle,
    _id: "discover-the-secrets-of-venice",
    coverImage:
        "https://images.unsplash.com/photo-1523365154888-8a758819b722?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80",
    time: cardStoriesReadTime,
    author: cardStoriesVendor,
    date: cardStoriesDate,
    tags: tagsFirst,
};

export const cardStoriesContents: ItalianStoriesResponseTo[] = [
    cardStoriesContent1,
    cardStoriesContent2,
    cardStoriesContent3,
    cardStoriesContent1,
    cardStoriesContent1,
    cardStoriesContent2,
    cardStoriesContent3,
    cardStoriesContent1,
    cardStoriesContent1,
    cardStoriesContent2,
    cardStoriesContent3,
    cardStoriesContent1,
];

const articleFirst: StoriesEntity[] = [
    {
        h2: "The Colosseum in Rome",
        body: `The Colosseum, also known as the Flavian Amphitheatre, is an oval amphitheatre in the center of Rome, Italy.
                    Built of concrete and sand, it is the largest amphitheatre ever built. The Colosseum is situated just east of the Roman Forum.
                    Construction began under the emperor Vespasian in AD 72, and was completed in AD 80 under his successor and heir Titus.
                    Further modifications were made during the reign of Domitian (81–96). These three emperors are known as the Flavian dynasty, and the amphitheatre was named in Latin for its association with their family name (Flavius)`,
        image: "https://images.unsplash.com/photo-1672391429233-9c63a794f24f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2831&q=80",
        citation:
            "Your private patio takes in the afternoon sun, letting you soak up unparalleled lake and mountain views by day and the stars & city lights by night.",
    },
    {
        h1: "The Leaning Tower of Pisa",
        body: `The Leaning Tower of Pisa is a freestanding bell tower, located behind the Cathedral of the Assumption of the Virgin, in the Piazza dei Miracoli in Pisa, Italy. 
                    It is the campanile, or freestanding bell tower, of the cathedral of the city's Metropolitan Cathedral of Pisa, which is the seat of the Bishop of Pisa.
                    The tower is situated behind the cathedral and is the third oldest structure in the city's Cathedral Square (Piazza del Duomo), after the cathedral and the Pisa Baptistry.
                    The tower's tilt began during construction, caused by an inadequate foundation on ground too soft on one side to properly support the structure's weight.
                    The tilt increased in the decades before the structure was completed when the ground on the soft side sank and the structure settled unevenly.`,
        image: "https://images.unsplash.com/photo-1543429776-2782fc8e1acd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2370&q=80",
        citation:
            "Your private patio takes in the afternoon sun, letting you soak up unparalleled lake and mountain views by day and the stars & city lights by night.",
    },
];

const italianStoryFirst: ItalianStoryResponseTo = {
    _id: randomUid(),
    title: "Explore the Best of Italy",
    author: "John Doe",
    authorImage:
        "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80",
    time: "5 minutes",
    date: "01-01-2022",
    coverImage:
        "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=983&q=80",
    tags: tagsFirst,
    stories: articleFirst,
    associatedBlogs: cardStoriesContents,
    internalName: "expore-the-best-of-italy",
};
export const newItalianStoryMockData: ItalianStoryResponseTo[] = [
    italianStoryFirst,
];
export const italianStoryMockData: IItalianStory[] = [
    {
        id: randomUid(),
        headTitle: "Discover the Secrets of Venice",
        slug: "discover-the-secrets-of-venice",
        title: "Explore the Best of Venice",
        imageUrl:
            "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=983&q=80",
        readTime: "7 minutes",
        author: "Jane Doe",
        authorImageUrl:
            "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80",
        date: "February 1, 2022",
        tags: ["Travel", "Venice"],
        stories: [
            {
                // eslint-disable-next-line sonarjs/no-duplicate-string
                h3: "The Leaning Tower of Venice",
                paragraph: `Tower of Venice is a freestanding bell tower, located behind the Cathedral of the Assumption of the Virgin, in the Piazza dei Miracoli in Pisa, Italy.
                    It is the campanile, or freestanding bell tower, of the cathedral of the city's Metropolitan Cathedral of Pisa, which is the seat of the Bishop of Pisa.
                    The tower is situated behind the cathedral and is the third oldest structure in the city's Cathedral Square (Piazza del Duomo), after the cathedral and the Pisa Baptistry.`,
                imageUrl:
                    "https://images.unsplash.com/photo-1650480163005-631cd625dfeb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2274&q=80",
                imageSubTitle: "The Leaning Tower of Venice",
                imageAlt: "The Leaning Tower of Venice",
                quote: "The Leaning Tower of Venice is one of the most famous landmarks in the world.",
                tour: "Take a guided tour of the The Leaning Tower of Venice",
            },
        ],
    },
];

export const italianStoriesHeadData: HeadSectionContent = {
    backgroundImageUrl:
        "https://images.unsplash.com/photo-1583855282680-6dbdc69b0932?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3000&q=80",
    title: [
        {
            text: "Italian Stories",
            color: colors.textWhiteLight,
            fontWeight: "fw-bold",
            newLine: true,
        },
    ],
    subTitle: [
        {
            text: "Hear authentic Italian stories directly by Italians",
            color: colors.textWhiteLight,
            fontWeight: "fw-bold",
            newLine: false,
        },
    ],
};

export const relatedArticlesTitle: SectionsTitleText[] = [
    {
        text: "Related Articles",
        color: colors.textBlack,
        fontWeight: "fw-bold",
        newLine: true,
    },
];

export const relatedArticlesSubTitle: SectionsTitleText[] = [
    {
        text: "If you liked this article, you may also like these other ones. Get inspired and find your dream Italian destination.",
        color: colors.textGrayLight,
        fontWeight: "",
        newLine: true,
    },
];
